// @flow
import { useContext } from 'react';
import { useMutation, MutationOptions, useQueryClient } from 'react-query';
import { getPrimaryFormData, savePrimaryFormData } from 'services/formService';
import { AppContext } from 'contexts/AppContext';
import useAbortController from 'hooks/useAbortController';
import QUERY_KEYS from 'constants/queryKeys';
import {
  PrimaryFormPayload,
  getPrimaryFormPayload,
} from './useSavePrimaryFormMutation.utils';

const useSavePrimaryFormMutation = ({
  options,
}: {
  options: MutationOptions,
} = {}) => {
  const abortControllerOptions = useAbortController();
  const { organizationId, propertyId, states } = useContext(AppContext);
  const queryClient = useQueryClient();

  return useMutation(
    async (update: PrimaryFormPayload) => {
      const initialData: PrimaryFormPayload = await getPrimaryFormData({
        organizationId,
        propertyId,
        applicantId: update.applicantId,
        options: abortControllerOptions,
      });

      const payload: PrimaryFormPayload = getPrimaryFormPayload({
        initialData,
        update,
        states,
      });

      return savePrimaryFormData({
        organizationId,
        propertyId,
        applicantId: update.applicantId,
        payload,
        options: abortControllerOptions,
      });
    },
    {
      ...options,
      onError: (error) => {
        options?.onError?.(error);
      },
      onSuccess: (response) => {
        queryClient.invalidateQueries(
          QUERY_KEYS.primaryFormData({ organizationId, propertyId }),
        );
        options?.onSuccess?.(response);
      },
    },
  );
};

export default useSavePrimaryFormMutation;
